import React, {useCallback, useEffect, useState} from 'react';

import {formatSimpleDateTimeFromISOString} from '../../../utils/dateFunctions';


export default function Readings({authFetch}) {
    const [readings, setReadings] = useState([]);
    const [types, setTypes] = useState([]);

    console.log("authFetch in Readings:", typeof authFetch);

    const fetchUserReadings = useCallback(async () => {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/reading/thirty-days`);
            console.log("Raw response:", response);
            if (!response) {
                console.error("No response received!");
                return;
            }
            const data = await response.json().catch(err => {
                console.error("JSON parse error:", err);
                return null;
            });
            console.log("Data:", data);
            setReadings(data || []);
        } catch (err) {
            console.error('Error fetching readings:', err.message);
        }
    }, [authFetch]);

    const fetchUserTypes = useCallback(async () => {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/type/all`);
            if (response.ok) {
                const data = await response.json();
                setTypes(data);
            } else {
                console.error('Failed to fetch types:', response.status);
            }
        } catch (err) {
            console.error('Error fetching types:', err.message);
        }
    }, [authFetch]);

    useEffect(() => {
        (async () => {
            try {
                await fetchUserReadings();
                await fetchUserTypes();
            } catch (err) {
                console.error(err);
                alert(err.message);
                window.location.href = '/login';
            }
        })();
    }, [fetchUserReadings, fetchUserTypes]);

    return readings.length > 0 && types.length > 0 && (
        <>
            <h2>All Readings Last 30 Days (All Types)</h2>

            <ul>
                {readings.map((reading) => {
                    const type = types.find((t) => t._id === reading.typeId);
                    if (!type) return null;

                    return (
                        <li key={reading._id}>
                            <a href={`/type/${type._id}`}>{type.name}</a>{' '}
                            ({reading.activeAmount}{type.activeUnits}){' '}
                            <a href={`/edit-reading/${reading._id}`}>
                                {formatSimpleDateTimeFromISOString(reading.dateTime)}
                            </a>{' '}
                            {reading.note}{' '}
                            <a href={`/edit-reading/${reading._id}`}>edit</a>
                        </li>
                    );
                })}
            </ul>
        </>
    );
}
